<ng-container *transloco="let t; read: 'user'">
  <div class="rounded-lg">

      <div class="flex justify-between border-b">
          <h1 class="text-[25px] font-bold">{{ t('manageEnrollment.sharedProviders.removeProvider') }}</h1>
          <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
      </div>
      <div id="delete-child-shared-provider" mat-dialog-content>
          <div class="my-5">{{ t('manageEnrollment.sharedProviders.removeConfirm') }}</div>
      </div>
      <div mat-dialog-actions class="flex justify-end align-bottom">
          <button mat-button mat-dialog-close>{{ t('manageEnrollment.viewChild.actions.cancel') }}</button>
          <drdp-btn mat-button [disabled]="" cdkFocusInitial
              (click)="onDelete()">{{ t('manageEnrollment.sharedProviders.removeProvider') }}</drdp-btn>
      </div>

  </div>
</ng-container>